import React from 'react';
import { branch, renderNothing } from 'recompose';

const Label = ({ children, ...otherProps }) => (
  <label {...otherProps}>{children}</label>
);

export default branch(
  ({ children }) => React.Children.count(children) === 0,
  renderNothing
)(Label);



// WEBPACK FOOTER //
// ./src/components/proxy/label.js